package net.frozenbit.games.soundgame.viewmodels

data class PlaybackStateInfo(
    val currentlyPlayingOption: Int?,
    val currentlyPlayingSound: Int?,

    val revealUpToOption: Int,
    val revealedSounds: Int,
)

internal fun AudioEventGenerator.VotingPlaybackState.present(): PlaybackStateInfo {
    val playbackStateInfo: PlaybackStateInfo = when (this) {
        is AudioEventGenerator.VotingPlaybackState.Idle ->
            PlaybackStateInfo(
                currentlyPlayingOption = this.optionIndex ?: Int.MIN_VALUE,
                currentlyPlayingSound = Int.MIN_VALUE,
                revealUpToOption = this.optionIndex ?: Int.MIN_VALUE,
                revealedSounds = Int.MIN_VALUE,
            )

        AudioEventGenerator.VotingPlaybackState.InitialPromptAnnouncement ->
            PlaybackStateInfo(
                currentlyPlayingOption = null,
                currentlyPlayingSound = null,
                revealUpToOption = Int.MIN_VALUE,
                revealedSounds = Int.MIN_VALUE,
            )

        is AudioEventGenerator.VotingPlaybackState.VotingOptionsPresentation ->
            PlaybackStateInfo(
                currentlyPlayingOption = this.optionIndex,
                currentlyPlayingSound = this.soundNumber,
                revealUpToOption = this.optionIndex,
                revealedSounds = this.soundNumber - 1, // dont spoil the currently playing sound
            )

        is AudioEventGenerator.VotingPlaybackState.VotingOptionsPresentationFinished ->
            PlaybackStateInfo(
                currentlyPlayingOption = this.optionIndex,
                currentlyPlayingSound = null,
                revealUpToOption = this.optionIndex,
                revealedSounds = Int.MAX_VALUE,
            )

        AudioEventGenerator.VotingPlaybackState.Finished ->
            PlaybackStateInfo(
                currentlyPlayingOption = null,
                currentlyPlayingSound = null,
                revealUpToOption = Int.MAX_VALUE,
                revealedSounds = Int.MAX_VALUE,
            )

        is AudioEventGenerator.VotingPlaybackState.Replaying ->
            PlaybackStateInfo(
                currentlyPlayingOption = this.optionIndex,
                currentlyPlayingSound = this.soundNumber,
                revealUpToOption = Int.MAX_VALUE,
                revealedSounds = Int.MAX_VALUE,
            )

        AudioEventGenerator.VotingPlaybackState.WinnerFinished ->
            PlaybackStateInfo(
                currentlyPlayingOption = null,
                currentlyPlayingSound = null,
                revealUpToOption = Int.MAX_VALUE,
                revealedSounds = Int.MAX_VALUE,
            )
    }
    return playbackStateInfo
}
